import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from "react";
import classNames from "classnames";
import { Icon, IconButton, IconConstants, makeStyles, RaiseColors } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    circleArrowButton: {
      backgroundColor: "".concat(RaiseColors.white, " !important"),
      transition: "background-color 0.15s ease-in-out",
      "&:hover": {
        backgroundColor: "".concat(RaiseColors.grayscale200, " !important")
      }
    },
    disabled: {
      backgroundColor: "none !important",
      cursor: "not-allowed",
      border: "1px solid ".concat(RaiseColors.grayscale200),
      "&:hover": {
        backgroundColor: "none !important"
      },
      "& .MuiIcon-root": {
        color: "".concat(RaiseColors.grayscale900, " !important")
      }
    }
  };
});
var CircleArrowButton = function CircleArrowButton(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "left" : _ref$direction,
    _ref$iconType = _ref.iconType,
    iconType = _ref$iconType === void 0 ? "chevron" : _ref$iconType,
    _ref$diameterPixels = _ref.diameterPixels,
    diameterPixels = _ref$diameterPixels === void 0 ? 40 : _ref$diameterPixels,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = useStyles();
  var iconMap = {
    chevron: {
      left: IconConstants.CHEVRON_LEFT,
      right: IconConstants.CHEVRON_RIGHT
    },
    arrow: {
      left: IconConstants.ARROW_LEFT,
      right: IconConstants.ARROW_RIGHT
    }
  };
  var icon = iconMap[iconType][direction];
  var handleClick = function handleClick() {
    if (!disabled) {
      onClick();
    }
  };
  return /*#__PURE__*/_jsx(IconButton, {
    onClick: handleClick,
    className: classNames(classes.circleArrowButton, _defineProperty({}, classes.disabled, disabled), className),
    disableHoverBackground: true,
    variant: "circle",
    width: "".concat(diameterPixels, "px"),
    height: "".concat(diameterPixels, "px"),
    disabled: disabled,
    children: /*#__PURE__*/_jsx(Icon, {
      fontSize: "xsmall",
      className: icon
    })
  });
};
export default CircleArrowButton;